export var Type;
(function (Type) {
    Type["Vocabulary"] = "vocabulary";
    Type["Transcript"] = "transcript";
})(Type || (Type = {}));
export default Type;
//# sourceMappingURL=Type.js.map